import type { BatchAddressAPI } from './Definitions/ApiTypes';
import { type BatchAddress, StatusAddress } from './Definitions/Types';

export function batchGeocodeTransformer(response: BatchAddressAPI[], rawAddresses: string[]): BatchAddress[] {
  return response.map((item: BatchAddressAPI, i: number) => {
    const { address } = item;

    if (item.status === 'ok') {
      const {
        location: { lat, lng },
      } = item;
      return {
        status: StatusAddress.Found,
        rawAddress: rawAddresses[i],
        address,
        lat,
        lng,
      };
    }

    return {
      status: StatusAddress.NotFound,
      rawAddress: rawAddresses[i],
      address: null,
    };
  });
}

export default batchGeocodeTransformer;
